export const footerLinkData = [
    {
      id: 1,
      title: "APP FEATURES",
      items: [
        { elem: "iPhone & iPad app", links: "/signup" },
        { elem: "Android app", links: "." },
        { elem: "Keto Diet", links: "." },
        { elem: "Low-Carb Diet", links: "." },
        { elem: "Premium Calorie Counting", links: "." },
        { elem: "MyNetDiary vs MyFitnessPal", links: "." },
      ],
    },
    {
      id: 2,
      title: "WEIGHT LOSS SCIENCE",
      items: [
        { elem: "Weight Loss Blog", links: "" },
        { elem: "Diet Library", links: "." },
        { elem: "Dietitian Team", links: "." },
      ],
    },
    {
      id: 3,
      title: "BUSINESS",
      items: [
        { elem: "Gift cards & Group discounts", links: "." },
        { elem: "For trainers", links: "." },
        { elem: "For healthcare professionals", links: "." },
        { elem: "For families", links: "." },
        { elem: "Food database licensing", links: "." },
      ],
    },
    {
      id: 4,
      title: "COMPANY",
      items: [
        { elem: "About MyNetDiary", links: "." },
        { elem: "In the News", links: "." },
        { elem: "Press Releases", links: "." },
        { elem: "Press Kit", links: "." },
      ],
    },
  ];
  
  
  
  
  export const dashFooterLinkData = [
    {
      id: 1,
      items: [
        { elem: "Success stories", links: "." },
        { elem: "Efficacy report", links: "." },
        { elem: "Member testimonials", links: "." },
        { elem: "Community", links: "." },
        { elem: "Dietitian's Blog", links: "." },
        { elem: "Ask a Dietitian", links: "." },
        { elem: "Instant food search", links: "." },
        { elem: "Diabetes and health tracking", links: "." },
      ],
    },
    {
      id: 2,
      items: [
        { elem: "iPhone/iPod app", links: "." },
        { elem: "Diet Library", links: "." },
        { elem: "iPad app", links: "." },
        { elem: "Android app", links: "." },
        { elem: "Diabetes app for iPhone", links: "." },
        { elem: "Diabetes app for Android", links: "." },
        { elem: "Products and features", links: "." },
        { elem: "Fitbit linking", links: "." },
        { elem: "Withings linking", links: "." },
        { elem: "Garmin linking", links: "." },
        { elem: "Twitter linkin", links: "." },
      ],
    },
    {
      id: 3,
      items: [
        { elem: "Gift cards & Group discounts", links: "." },
        { elem: "For trainers", links: "." },
        { elem: "For healthcare professionals", links: "." },
        { elem: "For families", links: "." }
      ],
    },
    {
      id: 4,
      items: [
        { elem: "Help", links: "." },
        { elem: "Learn more", links: "." },
        { elem: "Diet articles", links: "." },
        { elem: "About", links: "." },
        { elem: "Privacy policy", links: "." },
        { elem: "Terms of use", links: "." },
        { elem: "Contact us", links: "." },
      ],
    },
  ];